import React from "react";
import Context from "../../../../Context";
import Blocker from "../../../Misc/Blocker";
import Nl2Br from "../../../Misc/Nl2Br";
import ObjectLink from "../../../Misc/ObjectLink";
import ModelInfo from "../../Product/ModelInfo";
export default class WorkdocRequest extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pending: false,
      showModelInfo: false,
      currentModel: {},
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let items = await this.context.api.qa("/request/item/list", {
      filter: { documentid: this.props.id },
      orderby: ["itemid ASC"],
    });

    this.setState({ pending: false, items });
  };

  onModelInfoOpen = (item) => {
    this.setState({ showModelInfo: true, currentModel: item });
  };

  onModelInfoClose = () => {
    this.setState({ showModelInfo: false, currentModel: {} });
  };

  render() {
    const { items, pending, showModelInfo, currentModel } = this.state;
    const document = this.props.document || {};
    return (
      <>
        {showModelInfo && (
          <ModelInfo
            id={currentModel.id}
            label={currentModel.name}
            description={currentModel.description}
            onHide={this.onModelInfoClose}
          />
        )}
        <Blocker on={pending} hAuto>
          <h5>{document.label}</h5>
          <div className="mb-4">
            {document.description && (
              <div>
                Комментарий:{" "}
                <span className="text-muted">
                  <Nl2Br>{document.description}</Nl2Br>
                </span>
              </div>
            )}
          </div>

          <table className="table">
            <tbody>
              {items.map((item) => {
                let model = item.model || {};
                let currency = item.currency || {};
                let measure = item.measure || {};
                return (
                  <tr key={item.itemid}>
                    <td width="50%">
                      <div
                        className="cursor-pointer text-hover-primary"
                        onClick={() => this.onModelInfoOpen(model)}
                      >
                        {model.name}
                      </div>{" "}
                      <div className="small text-muted">
                        {model.description}{" "}
                        <span className="text-dark-50">{model.subcode}</span>
                      </div>
                    </td>
                    <td className="text-nowrap">
                      {item.deliverydate && (
                        <div>
                          до {new Date(item.deliverydate).toLocaleDateString()}
                        </div>
                      )}
                    </td>
                    <td className="text-nowrap">
                      {item.volume}{" "}
                      <span className="small text-muted">{measure.name}</span>
                    </td>
                    <td className="text-nowrap">
                      {item.price}{" "}
                      <span className="small text-muted">{currency.name}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="mt-4 pt-4 border-top">
            <ObjectLink title="Связанные документы" id={document.id} />
          </div>
        </Blocker>
      </>
    );
  }
}
